import PropTypes from 'prop-types'
import React, { Component } from 'react'
import {
    Container,
    Icon,
    Menu,
    Segment,
    Sidebar,
} from 'semantic-ui-react';
import { Link } from 'react-scroll';
import HomepageHeading from './HomepageHeading';
import { openInNewTab } from '../util/util';
import { Media } from '../util/util';


class MobileContainer extends Component {
    state = {}

    handleSidebarHide = () => this.setState({ sidebarOpened: false })

    handleToggle = () => this.setState({ sidebarOpened: true })

    render() {
        const { children } = this.props
        const { sidebarOpened } = this.state

        return (
            <Media as={Sidebar.Pushable} at='mobile'>
                <Sidebar.Pushable>
                    <Sidebar
                        as={Menu}
                        animation='overlay'
                        inverted
                        onHide={this.handleSidebarHide}
                        vertical
                        visible={sidebarOpened}
                    >
                        <Menu.Item as={ Link }
                            to="posts"
                            smooth={true}
                            duration={1000}
                            onClick={this.handleSidebarHide}
                        >Posts
                        </Menu.Item>
                        <Menu.Item as={ Link }
                            to="products"
                            smooth={true}
                            duration={1000}
                            onClick={this.handleSidebarHide}
                        >Products
                        </Menu.Item>
                        <Menu.Item as={ Link }
                            to="contact"
                            smooth={true}
                            duration={1000}
                            onClick={this.handleSidebarHide}
                        >Contact Us
                        </Menu.Item>
                        <Menu.Item position='right' as='d'>
                            <button onClick={() => {
                                this.handleSidebarHide();
                                openInNewTab("https://www.facebook.com/trinutspampanga");
                            }} class="ui icon blue button">
                                <i class="facebook icon"></i> @trinutspampanga
                            </button>
                        </Menu.Item>
                        <Menu.Item position='right' as='d'>
                            <button onClick={() => {
                                this.handleSidebarHide();
                                openInNewTab("https://g.page/trinuts");
                            }} class="ui icon red button">
                                <i class="google icon"></i> g.page/trinuts
                            </button>
                        </Menu.Item>
                    </Sidebar>

                    <Sidebar.Pusher dimmed={sidebarOpened}>
                        <Segment
                            inverted
                            textAlign='center'
                            style={{ minHeight: 350, padding: '1em 0em' }}
                            vertical
                        >
                            <Container>
                                <Menu inverted pointing secondary size='large'>
                                    <Menu.Item onClick={this.handleToggle}>
                                        <Icon name='sidebar' />
                                    </Menu.Item>
                                    <Menu.Item position='right'>
                                        <button onClick={() => openInNewTab("https://www.facebook.com/trinutspampanga")} class="ui icon blue button">
                                            <i class="facebook icon"></i>
                                        </button>
                                        &nbsp;
                                        &nbsp;
                                        <button onClick={() => openInNewTab("https://g.page/trinuts")} class="ui icon red button">
                                            <i class="google icon"></i>
                                        </button>
                                    </Menu.Item>
                                </Menu>
                            </Container>
                            <HomepageHeading mobile />
                        </Segment>

                        {children}
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </Media>
        )
    }
}

MobileContainer.propTypes = {
    children: PropTypes.node,
}

export default MobileContainer;